import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fNumber(number) {
  return numeral(number).format();
}

// export function fCurrency(number) {
//   const format = number !== null && number !== undefined   ? numeral(number).format('$0,0.00') : '';

//   return result(format, '.00');
// }

export function fCurrency(number) {
  if (number === null || number === undefined || number === '') {
    return '$0.00';
  }

  const format = numeral(number).format('$0,0.00');

  // Use result, but with a key that will NEVER match
  // so ".00" is preserved
  return result(format, '__KEEP_DECIMALS__');
}

export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

// src/utils/decimalInput.js
export const allowTwoDecimals = (value) => {
  // Allow empty (user can clear)
  if (value === '' || value === '-') return true;

  // Regex: optional -, digits, optional decimal with max 2 digits
  return /^-?\d*(\.\d{0,2})?$/.test(value);
};

  export const truncate = (name) =>
    name?.length > 10 ? name.slice(0, 10) + "..." : name;

